
jQuery(document).ready(function($) {

    $('video').each(function(){
        if (!$(this).hasClass('nojs')) {
            // Initialize Video.js player
            const video = videojs(this, {
                fluid: true,
                controls: true,
                disablePictureInPicture: false,
                enableDocumentPictureInPicture: true,
                enableSmoothSeeking: true
            });
            $(this).data('vjs', video);
        }
    });


    $('.video-player').each(function() {
        const container = $(this);
        const carousel = container.find('.video-carousel');
        const playlist = container.find('.video-playlist');

        carousel.on('slide.bs.carousel', function(e) {
            const activeVideo = $(this).find('.active video');
            let vjs = activeVideo.data('vjs');

            if (vjs.isFullscreen()) {
                vjs.exitFullscreen();
            }
            if (!vjs.paused()) {
                vjs.pause();
            }
        });

        carousel.on('slid.bs.carousel', function(e) {
            const activeVideo = $(this).find('.active video');
            let vjs = activeVideo.data('vjs');

            playlist.find('.list-group-item').removeClass('active');
            $(playlist.find('.list-group-item').get(e.to)).addClass('active');

            if (vjs.paused()) {
                vjs.play();
            }
        });

    });



});
